// extracted by mini-css-extract-plugin
module.exports = {"gallery":"image-gallery-module--gallery--1MZnF","galleryImage":"image-gallery-module--galleryImage--RiXQY"};